import React from 'react';
import { Icon, Radio, RadioGroup, theme, Tooltip, Space } from 'components';
import styled from 'styled-components';

type AdvancedSelectorProps = {
  clickHandler: any;
  advConfSetting: boolean;
  noMoreShowings: boolean;
  disableAutoConfirm: boolean;
};

const AdvancedSelector: React.FC<AdvancedSelectorProps> = ({
  clickHandler,
  advConfSetting,
  noMoreShowings,
  disableAutoConfirm = false,
}) => (
    <AdvancedSelectorContainer>
      <StyledHeading>
        Custom Selector
        <Tooltip
          id="tooltip"
          title="Partially enable auto-confirmation on appointments for only certain time
      periods."
        >
          <span>
            <Icon width={16} type="antdInfoCircleFilled" />
          </span>
        </Tooltip>
      </StyledHeading>
      <StyledHr />
      <form>
        <RadioGroup
          onChange={clickHandler}
          value={advConfSetting ? 'advAutoConfEnabled' : 'advAutoConfDisabled'}
        >
          <Space direction="vertical" size="small">
            <Radio
              name="advAutoConf"
              value={'advAutoConfDisabled'}
              type="radio"
              data-cy="adv-auto-conf-disable"
            >
              <StyledLabel>Available / Restricted</StyledLabel>
            </Radio>

            <Radio
              name="advAutoConf"
              value={'advAutoConfEnabled'}
              onChange={clickHandler}
              disabled={disableAutoConfirm || !!noMoreShowings}
              data-cy="adv-auto-conf-enable"
            >
              <Tooltip
                title={
                  noMoreShowings &&
                  'Auto-confirm is disabled. To select this option, disable Turn Off Showings.'
                }
              >
                <StyledLabel>
                  Auto-Confirm{' '}
                  <span>
                    <StyledIcon
                      advConfigSetting={advConfSetting}
                      width={12}
                      type="antdThunderBoltFilled"
                    />
                  </span>
                </StyledLabel>
              </Tooltip>
            </Radio>
          </Space>
        </RadioGroup>
      </form>
    </AdvancedSelectorContainer>
  );

export default AdvancedSelector;

const AdvancedSelectorContainer = styled.div`
  font-family: ${theme.fontFamily};
  height: 100%;
  width: fit-content;
  margin-right: 10px;
  border-radius: 1em;
  background: ${theme.gray2};
  padding: 10px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const StyledHeading = styled.p`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  font-weight: 500;
  color: black;
  margin: 0;
`;

const StyledHr = styled.hr`
  margin: 10px 0px !important;
`;

const StyledIcon = styled(Icon)<{ advConfigSetting: any }>`
  svg {
    color: ${({ advConfigSetting }) => advConfigSetting && '#5cb85c'};
    animation: glow 3s ease-in-out infinite alternate;
  }
`;

const StyledLabel = styled.span`
  font-weight: normal;
`;
